import { useFetcher } from "@remix-run/react";
import type { FocusEventHandler } from "react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocalePath } from "./useLocale";

export const useCheckEmail = () => {
  const isCustomerEmailAvailable = useFetcher<{
    res: boolean;
    errors: string[];
  }>();
  const [isCheckEmail, setIsCheckEmail] = useState(false);
  useEffect(() => {
    setIsCheckEmail((v) => v || !!isCustomerEmailAvailable.data);
  }, [isCustomerEmailAvailable.data]);

  const isEmailAvailable = useMemo(() => {
    if (!isCustomerEmailAvailable.data) return [];
    const { errors, res } = isCustomerEmailAvailable.data;
    if (errors && errors.length) return errors;
    if (res) return [];
    return ["account_message_email_exists"];
  }, [isCustomerEmailAvailable.data]);

  const isCheckingEmail = useMemo(
    () => isCustomerEmailAvailable.submission,
    [isCustomerEmailAvailable.submission]
  );

  const localePath = useLocalePath();
  const checkEmail = useCallback<FocusEventHandler<HTMLInputElement>>(
    (e) => {
      if ((e.target.value || "").trim()) {
        isCustomerEmailAvailable.submit(
          { email: e.target.value.trim() },
          { method: "get", action: localePath(`/email-available`) }
        );
      }
    },
    [isCustomerEmailAvailable, localePath]
  );

  const customCheckEmail = useCallback(
    (email: string) => {
      if ((email || "").trim()) {
        isCustomerEmailAvailable.submit(
          { email: email.trim() },
          { method: "get", action: localePath(`/email-available`) }
        );
      }
    },
    [isCustomerEmailAvailable, localePath]
  );

  return {
    checkEmail,
    customCheckEmail,
    isCheckingEmail,
    isCheckEmail,
    isEmailAvailable,
  };
};
